/**
 * Translated FAQ body.
 * Mirrors the English CMS HTML for page_id "faq".
 */

const frenchFaq = `
<div class="legal-page container">
      <h1>Foire aux questions</h1>
      <p class="last-updated"><em>Dernière mise à jour : octobre 2025</em></p>

      <p class="intro-text">
        Trouvez des réponses aux questions fréquentes sur Cranford Publications, nos produits, les commandes et nos politiques. Vous ne trouvez pas ce que vous cherchez ? Écrivez-nous !
      </p>

      <h2>🎵 Questions générales</h2>

      <h3>Qu'est-ce que Cranford Publications ?</h3>
      <div class="info-box">
        <p>
          Cranford Publications est une maison d'édition spécialisée dans la musique celtique et cap-bretonne traditionnelle, en particulier le violon. Nous publions des livres, des enregistrements et du matériel pédagogique mettant en valeur le travail de musiciens et de compositeurs reconnus. <strong>Fondée en 1979</strong>, nous servons la communauté de la musique celtique depuis plus de 40 ans.
        </p>
      </div>

      <h3>Quels types de produits offrez-vous ?</h3>
      <p>Nous proposons une vaste gamme de produits, notamment :</p>
      <ul>
        <li>📚 Des livres de musique avec airs traditionnels et notation</li>
        <li>💿 Des CD et enregistrements numériques de musique celtique</li>
        <li>📖 Des biographies et mémoires de musiciens</li>
        <li>🎓 Du matériel pédagogique pour apprendre la musique traditionnelle</li>
        <li>📜 Des publications historiques et culturelles</li>
      </ul>

      <h3>Quel est le format des livres de musique ?</h3>
      <div class="highlight-box">
        <p>
          Tous nos livres présentent une notation claire, composée professionnellement, avec des symboles d'accords le cas échéant. La plupart dépassent 100 pages et comprennent des notes historiques et des renseignements sur les airs.
        </p>
      </div>

      <h2>💳 Commandes et paiement</h2>

      <h3>Comment passer une commande ?</h3>
      <p>
        Parcourez nos produits, ajoutez-les au panier, puis passez à la caisse. Vous pouvez créer un compte pour accélérer les achats suivants ou commander en tant qu'invité.
      </p>

      <h3>Quels modes de paiement acceptez-vous ?</h3>
      <div class="info-box">
        <p><strong>Nous acceptons :</strong></p>
        <ul>
          <li>💳 Les principales cartes de crédit (Visa, MasterCard, American Express)</li>
          <li>🅿️ PayPal</li>
          <li>💵 Les mandats en dollars canadiens ou américains</li>
          <li>🏦 Les chèques certifiés en dollars canadiens ou américains</li>
        </ul>
        <p>Tous les paiements en ligne sont traités de façon sécurisée par notre processeur de paiement.</p>
      </div>

      <h3>Mes renseignements de paiement sont-ils sécurisés ?</h3>
      <p>
        Oui. Nous utilisons un chiffrement et des mesures de sécurité conformes à l'industrie. Nous ne stockons pas les détails de carte de crédit sur nos serveurs : le traitement est assuré par des processeurs tiers sécurisés.
      </p>

      <h3>Dans quelle devise sont vos prix ?</h3>
      <div class="info-note">
        <strong>Devise :</strong> tous les prix du site sont affichés en <strong>dollars canadiens (CAD)</strong>, sauf indication contraire.
      </div>

      <h2>📦 Livraison</h2>

      <h3>Combien de temps prend la livraison ?</h3>
      <p>Les commandes sont généralement traitées en 2 à 3 jours ouvrables. Les délais varient selon le lieu :</p>
      <div class="info-box">
        <ul>
          <li><strong>🇨🇦 Canada :</strong> 5 à 10 jours ouvrables</li>
          <li><strong>🇺🇸 États-Unis :</strong> 7 à 14 jours ouvrables</li>
          <li><strong>🌍 International :</strong> 2 à 4 semaines</li>
        </ul>
      </div>

      <h3>Offrez-vous la livraison gratuite ?</h3>
      <div class="highlight-box">
        <p>Oui ! Nous offrons la <strong>livraison standard gratuite au Canada pour les commandes de plus de 50 $</strong>. 🎉</p>
      </div>

      <h3>Livrez-vous à l'international ?</h3>
      <p>
        Oui, nous expédions vers la plupart des pays. Les tarifs et les délais varient selon la destination. Les clients sont responsables des droits de douane ou taxes de leur pays.
      </p>

      <h3>Puis-je suivre ma commande ?</h3>
      <p>
        Oui. Une fois la commande expédiée, vous recevez un numéro de suivi par courriel pour suivre le colis sur le site du transporteur.
      </p>

      <h2>🔄 Retours et échanges</h2>

      <h3>Quelle est votre politique de retour ?</h3>
      <p>
        Nous acceptons le retour des articles non ouverts dans les 30 jours suivant la livraison, pour un remboursement complet. Les articles doivent être dans leur état et leur emballage d'origine. Consultez notre <a href="/return-policy">politique de retours</a> pour tous les détails.
      </p>

      <h3>Puis-je échanger un produit ?</h3>
      <p>
        Nous remplaçons uniquement les articles défectueux ou endommagés à l'arrivée. Si vous devez faire un échange, communiquez avec nous dès que possible.
      </p>

      <h2>📚 Produits et contenu</h2>

      <h3>Les livres conviennent-ils aux débutants ?</h3>
      <div class="info-box">
        <p>
          Nos livres s'adressent à divers niveaux. Beaucoup d'airs sont de niveau intermédiaire à avancé, mais les débutants motivés peuvent tout de même les utiliser. Chaque livre contient une gamme de difficultés. Si vous hésitez, écrivez-nous pour une recommandation.
        </p>
      </div>

      <h3>Offrez-vous des téléchargements numériques ?</h3>
      <p>
        Oui, plusieurs de nos enregistrements sont offerts en téléchargement. Les produits numériques sont livrés dès l'achat, par courriel, avec les consignes de téléchargement.
      </p>

      <h3>Puis-je retélécharger mes achats numériques ?</h3>
      <p>
        Oui. Vous pouvez y accéder en tout temps depuis le tableau de bord de votre compte. Nous recommandons de conserver une copie de sauvegarde sur votre appareil.
      </p>

      <h2>👤 Compte et confidentialité</h2>

      <h3>Dois-je créer un compte pour acheter ?</h3>
      <p>Non, vous pouvez commander en tant qu'invité. Un compte vous permet toutefois de :</p>
      <ul>
        <li>Suivre l'historique de vos commandes</li>
        <li>Accéder aux téléchargements numériques</li>
        <li>Enregistrer votre adresse de livraison pour accélérer la caisse</li>
        <li>Recevoir des nouvelles sur les produits et les offres</li>
      </ul>

      <h3>Comment protégez-vous ma vie privée ?</h3>
      <p>
        Nous nous engageons à protéger votre vie privée. Consultez notre <a href="/privacy-policy">politique de confidentialité</a> pour savoir comment nous recueillons, utilisons et protégeons vos renseignements.
      </p>

      <h2>💻 Soutien technique</h2>

      <h3>J'ai un problème avec le site. Que faire ?</h3>
      <p>
        Essayez d'actualiser la page ou de vider le cache du navigateur. Si le problème persiste, écrivez-nous en précisant le navigateur utilisé et tout message d'erreur.
      </p>

      <h3>Le site fonctionne-t-il sur mobile ?</h3>
      <div class="highlight-box">
        <p>Oui ! Le site est entièrement adaptatif et fonctionne sur téléphones et tablettes. 📱</p>
      </div>

      <h2>🏢 Renseignements sur l'entreprise</h2>

      <h3>Où êtes-vous situés ?</h3>
      <div class="info-box">
        <p>
          Nous sommes situés sur l'île du Cap-Breton, en Nouvelle-Écosse, au Canada. Notre adresse :<br><br>
          <strong>Cranford Publications</strong><br>
          44549 Cabot Trail, RR#1<br>
          Englishtown, Cape Breton Island<br>
          Nouvelle-Écosse, Canada B0C 1H0
        </p>
        <p class="info-note"><em>Note : nous sommes une entreprise postale à domicile, sans magasin physique.</em></p>
      </div>

      <h3>Quelles sont vos heures d'ouverture ?</h3>
      <p>
        En général, de <strong>9 h à 18 h, heure de l'Atlantique (HNA)</strong>, la plupart des jours. Nous répondons habituellement aux demandes en 1 ou 2 jours ouvrables.
      </p>
    </div>
`;

const germanFaq = `
<div class="legal-page container">
      <h1>Häufig gestellte Fragen</h1>
      <p class="last-updated"><em>Zuletzt aktualisiert: Oktober 2025</em></p>

      <p class="intro-text">
        Antworten auf häufige Fragen zu Cranford Publications, unseren Produkten, Bestellungen und Richtlinien. Sie finden nicht, was Sie suchen? Schreiben Sie uns!
      </p>

      <h2>🎵 Allgemeine Fragen</h2>

      <h3>Was ist Cranford Publications?</h3>
      <div class="info-box">
        <p>
          Cranford Publications ist ein spezialisierter Verlag für traditionelle keltische und Cape-Breton-Musik, besonders für Geigenmusik. Wir veröffentlichen Bücher, Aufnahmen und Lernmaterialien bekannter Musiker und Komponisten. <strong>Gegründet 1979</strong>, betreuen wir die keltische Musikgemeinschaft seit über 40 Jahren.
        </p>
      </div>

      <h3>Welche Produkte bieten Sie an?</h3>
      <p>Unser Angebot umfasst unter anderem:</p>
      <ul>
        <li>📚 Notenbücher mit traditionellen Stücken</li>
        <li>💿 CDs und digitale Aufnahmen keltischer Musik</li>
        <li>📖 Biografien und Erinnerungen von Musikern</li>
        <li>🎓 Lernmaterialien für traditionelle Musik</li>
        <li>📜 Historische und kulturelle Veröffentlichungen</li>
      </ul>

      <h3>In welchem Format sind die Notenbücher?</h3>
      <div class="highlight-box">
        <p>
          Alle Bücher enthalten klar gesetzte, professionelle Notation mit Akkordsymbolen, wo sinnvoll. Die meisten haben über 100 Seiten sowie historische Hinweise und Informationen zu den Stücken.
        </p>
      </div>

      <h2>💳 Bestellung und Zahlung</h2>

      <h3>Wie bestelle ich?</h3>
      <p>
        Durchstöbern Sie die Produkte, legen Sie Artikel in den Warenkorb und gehen Sie zur Kasse. Sie können ein Konto anlegen oder als Gast bestellen.
      </p>

      <h3>Welche Zahlungsmethoden akzeptieren Sie?</h3>
      <div class="info-box">
        <p><strong>Wir akzeptieren:</strong></p>
        <ul>
          <li>💳 gängige Kreditkarten (Visa, MasterCard, American Express)</li>
          <li>🅿️ PayPal</li>
          <li>💵 Zahlungsanweisungen in kanadischen oder US-Dollar</li>
          <li>🏦 bestätigte Schecks in kanadischen oder US-Dollar</li>
        </ul>
        <p>Alle Online-Zahlungen werden sicher über unseren Zahlungsdienstleister abgewickelt.</p>
      </div>

      <h3>Sind meine Zahlungsdaten sicher?</h3>
      <p>
        Ja. Wir nutzen branchenübliche Verschlüsselung. Kreditkartendaten speichern wir nicht auf unseren Servern – die Abwicklung erfolgt über sichere Drittanbieter.
      </p>

      <h3>In welcher Währung sind die Preise?</h3>
      <div class="info-note">
        <strong>Währung:</strong> Alle Preise auf der Website sind in <strong>kanadischen Dollar (CAD)</strong>, sofern nicht anders angegeben.
      </div>

      <h2>📦 Versand und Lieferung</h2>

      <h3>Wie lange dauert der Versand?</h3>
      <p>Bestellungen werden in der Regel innerhalb von 2–3 Werktagen bearbeitet. Lieferzeiten je nach Ort:</p>
      <div class="info-box">
        <ul>
          <li><strong>🇨🇦 Kanada:</strong> 5–10 Werktage</li>
          <li><strong>🇺🇸 Vereinigte Staaten:</strong> 7–14 Werktage</li>
          <li><strong>🌍 International:</strong> 2–4 Wochen</li>
        </ul>
      </div>

      <h3>Gibt es kostenlosen Versand?</h3>
      <div class="highlight-box">
        <p>Ja! <strong>Kostenloser Standardversand innerhalb Kanadas bei Bestellungen über 50 $</strong>. 🎉</p>
      </div>

      <h3>Versenden Sie international?</h3>
      <p>
        Ja, in die meisten Länder. Tarife und Lieferzeiten hängen vom Zielort ab. Zoll und Steuern im Empfängerland trägt der Kunde.
      </p>

      <h3>Kann ich meine Bestellung verfolgen?</h3>
      <p>
        Ja. Nach dem Versand erhalten Sie per E-Mail eine Sendungsnummer, mit der Sie das Paket auf der Website des Transporteurs verfolgen können.
      </p>

      <h2>🔄 Rückgaben und Umtausch</h2>

      <h3>Wie ist Ihre Rückgaberichtlinie?</h3>
      <p>
        Ungeöffnete Artikel können innerhalb von 30 Tagen nach Lieferung gegen volle Erstattung zurückgegeben werden. Sie müssen im Originalzustand und in der Originalverpackung sein. Einzelheiten stehen in unserer <a href="/return-policy">Rückgaberichtlinie</a>.
      </p>

      <h3>Kann ich ein Produkt umtauschen?</h3>
      <p>
        Wir ersetzen Artikel nur, wenn sie bei Ankunft defekt oder beschädigt sind. Kontaktieren Sie uns bitte so schnell wie möglich.
      </p>

      <h2>📚 Produkte und Inhalte</h2>

      <h3>Eignen sich die Bücher für Anfänger?</h3>
      <div class="info-box">
        <p>
          Unsere Bücher decken verschiedene Niveaus ab. Viele Stücke sind mittel bis fortgeschritten, motivierte Anfänger können sie aber nutzen. Jedes Buch enthält unterschiedliche Schwierigkeitsgrade. Bei Unsicherheit empfehlen wir gerne ein Titel.
        </p>
      </div>

      <h3>Bieten Sie digitale Downloads an?</h3>
      <p>
        Ja, viele Aufnahmen gibt es als Download. Digitale Produkte werden nach dem Kauf sofort per E-Mail mit Download-Hinweisen geliefert.
      </p>

      <h3>Kann ich digitale Käufe erneut herunterladen?</h3>
      <p>
        Ja. Sie finden sie jederzeit im Konto-Dashboard. Wir empfehlen, eine Sicherungskopie auf Ihrem Gerät zu behalten.
      </p>

      <h2>👤 Konto und Datenschutz</h2>

      <h3>Brauche ich ein Konto zum Bestellen?</h3>
      <p>Nein, Sie können als Gast bestellen. Ein Konto ermöglicht Ihnen:</p>
      <ul>
        <li>Ihre Bestellhistorie zu verfolgen</li>
        <li>digitale Downloads abzurufen</li>
        <li>die Lieferadresse für schnellere Kasse zu speichern</li>
        <li>Neuigkeiten zu Produkten und Angeboten zu erhalten</li>
      </ul>

      <h3>Wie schützen Sie meine Privatsphäre?</h3>
      <p>
        Der Schutz Ihrer Daten ist uns wichtig. In unserer <a href="/privacy-policy">Datenschutzrichtlinie</a> erfahren Sie, wie wir personenbezogene Daten erheben, nutzen und schützen.
      </p>

      <h2>💻 Technischer Support</h2>

      <h3>Die Website funktioniert nicht. Was tun?</h3>
      <p>
        Bitte Seite neu laden oder den Browser-Cache leeren. Bleibt das Problem, schreiben Sie uns mit Browser und eventuellen Fehlermeldungen.
      </p>

      <h3>Funktioniert die Website auf dem Handy?</h3>
      <div class="highlight-box">
        <p>Ja! Die Website ist vollständig responsiv und funktioniert auf Smartphones und Tablets. 📱</p>
      </div>

      <h2>🏢 Unternehmensdaten</h2>

      <h3>Wo sind Sie?</h3>
      <div class="info-box">
        <p>
          Wir sind auf Cape Breton Island in Nova Scotia, Kanada. Unsere Adresse:<br><br>
          <strong>Cranford Publications</strong><br>
          44549 Cabot Trail, RR#1<br>
          Englishtown, Cape Breton Island<br>
          Nova Scotia, Kanada B0C 1H0
        </p>
        <p class="info-note"><em>Hinweis: Wir sind ein Versandgeschäft von zu Hause aus, ohne Ladenlokal.</em></p>
      </div>

      <h3>Wann sind Sie erreichbar?</h3>
      <p>
        In der Regel <strong>9:00–18:00 Atlantic Standard Time (AST)</strong>, an den meisten Tagen. Anfragen beantworten wir üblicherweise innerhalb von 1–2 Werktagen.
      </p>
    </div>
`;

export const FAQ_PAGE_TRANSLATIONS = {
  'fr-CA': {
    title: 'Foire aux questions',
    description:
      'Réponses aux questions fréquentes sur nos produits, commandes, livraison et politiques.',
    html: frenchFaq,
  },
  'fr-FR': {
    title: 'Foire aux questions',
    description:
      'Réponses aux questions fréquentes sur nos produits, commandes, livraison et politiques.',
    html: frenchFaq,
  },
  de: {
    title: 'Häufig gestellte Fragen',
    description:
      'Antworten auf häufige Fragen zu Produkten, Bestellung, Versand und Richtlinien.',
    html: germanFaq,
  },
};
